import { ReactNode, useState } from 'react';
import FileSectionToggleRow from '@/components/common/FileSectionToggleRow';

/** A labelled, foldable run of file rows; renders nothing when empty. */
export default function FoldableFileSection<T>({
  label,
  files,
  defaultOpen,
  renderRow,
  cellClassName,
}: {
  label: string;
  files: T[];
  defaultOpen: boolean;
  renderRow: (file: T) => ReactNode;
  cellClassName?: string;
}) {
  const [open, setOpen] = useState(defaultOpen);
  if (files.length === 0) return null;

  return (
    <>
      <FileSectionToggleRow
        label={label}
        count={files.length}
        open={open}
        onToggle={() => setOpen((v) => !v)}
        cellClassName={cellClassName}
      />
      {open && files.map(renderRow)}
    </>
  );
}
